import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 1L3 2V4H1V6H2.10496L3.00612 14.1104L4 15H12L12.9939 14.1104L13.895 6H15V4H13V2L12 1H4ZM11.8827 6H9V13L11.105 13L11.8827 6ZM7 13V6H4.11727L4.89504 13L7 13ZM11 4V3H5V4H11Z",
		fill: "black"
	})
});
export default SvgTrash;
